import styled from 'styled-components'

//Item
export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 2px 12px;
  border-top: 1px solid #e9ecef;
  cursor: pointer;

  :hover {
    transition: transform 0.3s;
    transform: scale(1.05);
  }
`
export const ItemBoxIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ItemName = styled.div`
  padding: 0 10px;
  font-weight: 600;
  opacity: 0.8;
`
export const ItemQtde = styled.div`
  font-size: 12px;
  text-align: center;
  margin-left: auto;
  padding: 2px 10px;
  color: #fff;
  background-color: var(--danger);
  border-radius: 10rem;
`
